import axios from 'axios';
import axiosRetry from 'axios-retry';

axiosRetry(axios, { retries: 3 }, { retryDelay: (retryCount) => retryCount * 5000 });

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.response.use((response) => {
  if (response?.data?.result !== 'SUCCESS' && !Array.isArray(response.data)) {
    throw response;
  } else {
    return response.data;
  }
}, (error) => {
  throw error;
});

export default {
  async createVerificationSessionsFromList(clientId, reservations) {
    const responses = [];

    for (let i = 0; i < reservations.length; i += 1) {
      const reservation = reservations[i];

      // eslint-disable-next-line no-await-in-loop
      responses.push(await api
        .post('/verifications/identity/streamline', {
          clientId,
          reservationId: reservation.reservationId,
          guest: {
            firstName: reservation.firstName,
            lastName: reservation.lastName,
            email: reservation.email,
            phoneNumber: reservation.phoneNumber,
            street: reservation.street,
            city: reservation.city,
            state: reservation.state,
            postalCode: reservation.postalCode,
            country: reservation.country,
          },
        })
        .then((response) => response)
        .catch((error) => error.data));
    }

    return responses;
  },
};
